<label>{{ label }}</label>
@if (control && !type) {
  <input
    [formControl]="$any(control)"
    class="item"
    [class.error]="showError"
    [type]="inputType || null"
    [autocomplete]="inputType === 'password' ? 'new-password' : null"
  />
}
@if (type) {
  <button
    [matMenuTriggerFor]="menu"
    class="menu-button item"
    [class.error]="showError"
    [class.light-text]="lightText"
    (click)="onMenuButton($event)"
  >
    <span>{{ menuButtonDisplay || 'Select' }}</span>
    <img src="assets/img/icons/caret-down-brown.svg" />
  </button>
}
<mat-menu #menu="matMenu" class="oph-select-menu">
  @for (option of options; track option) {
    <button (click)="onOption(option)" class="oph-select-menu-item">
      <span>{{ option.display }}</span>
    </button>
  }
</mat-menu>
